import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Seo } from '../../components/common/Seo';
import ErrorForm from '../../components/forms/ErrorForm';
import PasswordRequestForm from './forms/PasswordRequestForm';
import PasswordResetForm from './forms/PasswordResetForm';
import PasswordRequestSent from './PasswordRequestSent';
import PasswordResetSuccess from './PasswordResetSuccess';

const ResetPasswordComponent = () => {
  const navigate = useNavigate();
  const searchQueryParams = useSearchParams()[0];
  const resetPasswordToken = searchQueryParams.get('resetPasswordToken');
  const [pageStep, setPageStep] = useState(resetPasswordToken ? 'emailVerified' : 'request');

  return (
    <>
      <div className={`z-10 w-full rounded-lg bg-white p-6`}>
        {
          {
            request: <PasswordRequestForm setPageStep={setPageStep} />,
            emailSend: <PasswordRequestSent />,
            emailVerified: <PasswordResetForm setPageStep={setPageStep} resetPasswordToken={resetPasswordToken} />,
            resetPasswordSuccess: <PasswordResetSuccess />,
            error: <ErrorForm onClick={() => navigate(`/login`)} />,
          }[pageStep]
        }
      </div>
      <Seo title={'Réinitialiser votre mot de passe'} />
    </>
  );
};

export default ResetPasswordComponent;
